import Post from "../Post";

export default function phoneLogin(phone) {
  return Post("user/loginByPhone", {
    phone: phone,
  });
}
